import * as exportExcelUrl from 'src/helpers/url_helper';
import { apiSlice } from 'src/rtk/api/apiSlice';

export const exportExcel = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['ExportExcel'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({

      getCourseApprovalListExcel: builder.query<Blob, string>({
        query: (url) => ({
          method: 'GET',
          url: `${exportExcelUrl.GET_EXPORT_CSV_COURSE_APPLICATION_LIST}?${url}`,
          responseHandler: (response: any) => response.blob(),
        }),
        providesTags: ['ExportExcel'],
      }),
      getRegistrationInfoListExcel: builder.query<Blob, string>({
        query: (url) => ({
          method: 'GET',
          url: `${exportExcelUrl.GET_EXPORT_CSV_REGISTRATION_LIST}?${url}`,
          responseHandler: (response: any) => response.blob(),
        }),
        providesTags: ['ExportExcel'],
      }),
      getAllowanceInfoListExcel: builder.query<Blob, string>({
        query: (url) => ({
          method: 'GET',
          url: `${exportExcelUrl.GET_EXPORT_CSV_ALLOWANCE_LIST}?${url}`,
          responseHandler: (response: any) => response.blob(),
        }),
        providesTags: ['ExportExcel'],
      }),

      getThesisExamApplicantListExcel: builder.query<Blob, string>({
        query: (url) => ({
          method: 'GET',
          url: `${exportExcelUrl.GET_EXPORT_CSV_THESIS_EXAM_APPLICANT_LIST}?${url}`,
          responseHandler: (response: any) => response.blob(),
        }),
        providesTags: ['ExportExcel'],
      }),

      getMidTermEligibleTraineeListExcel: builder.query<Blob, string>({
        query: (url) => ({
          method: 'GET',
          url: `${exportExcelUrl.GET_EXPORT_CSV_MIDTERM_ELIGIBLE_TRAINEE_LIST}?${url}`,
          responseHandler: (response: any) => response.blob(),
        }),
        providesTags: ['ExportExcel'],
      }),


    }),
  });

export const {
  useLazyGetCourseApprovalListExcelQuery,
  useLazyGetRegistrationInfoListExcelQuery,
  useLazyGetAllowanceInfoListExcelQuery,
  useLazyGetThesisExamApplicantListExcelQuery,
  useLazyGetMidTermEligibleTraineeListExcelQuery,
} = exportExcel;
